<nz-skeleton
  [nzActive]="true"
  [nzLoading]="isLoading"
  *ngIf="isLoading"
  class="pt-2"
>
</nz-skeleton>

<ng-container *ngIf="groupedOddsList.length && !isLoading && !isMatch">
  <div *ngFor="let singleItem of groupedOddsList; let i = index">
    <app-expansion-panel [isOpen]="!singleItem.active">
      <div
        expansion-panel-header
        class="relative grid grid-cols-12 bg-red-4 text-grey-1 mt-4 p-4 max-sm:py-3 max-sm:px-2 rounded-5 items-center max-sm:mt-2 cursor-pointer font-roboto-500"
      >
        <div
          class="flex items-center gap-4 col-span-9 max-sm:col-span-6 max-sm:gap-1"
        >
          <img
            alt="logo"
            class="w-[40px] h-[40px] max-sm:w-[20px] max-sm:h-[20px] object-contain"
            [src]="urlIMG + 'default.png'"
          />
          <div class="text-18 max-sm:text-11 hover:underline">
            {{ singleItem.championshipName }} • {{ singleItem.country }}
          </div>
        </div>

        <div
          class="col-span-1 max-sm:col-span-2 max-sm:text-11 justify-self-center"
        >
          1
        </div>
        <div
          class="col-span-1 max-sm:col-span-2 max-sm:text-11 justify-self-center"
        >
          X
        </div>
        <div
          class="col-span-1 max-sm:col-span-2 max-sm:text-11 justify-self-center"
        >
          2
        </div>

        <img
          alt="logo"
          [src]="urlIcon + 'arrow-down-red.svg'"
          class="max-sm:w-[7px] absolute right-4"
        />
      </div>

      <div expansion-panel-content>
        <div
          *ngFor="let result of singleItem.results"
          class="grid grid-cols-12 bg-white my-4 px-4 py-3 max-sm:py-2 max-sm:px-2 rounded-6 min-h-[90px] max-sm:min-h-[60px] items-center text-grey-2 font-Roboto-400 text-17 max-sm:text-12 max-sm:my-2"
        >
          <div
            class="flex items-center justify-between gap-1 col-span-7 max-sm:hidden"
          >
            <!-- Home Team -->
            <div class="flex items-center gap-2 flex-1 min-w-0">
              <span class="hover:underline text-wrap truncate">{{
                result.homeTeam
              }}</span>
            </div>

            <!-- VS or Scores -->
            <div
              class="flex-none w-[50px] max-sm:w-[30px] vs-container relative font-roboto-500 text-blue text-14 max-sm:text-10 pl-4 pr-10"
            >
              <span class="absolute bg-white content">VS</span>
            </div>

            <!-- Away Team -->
            <div
              class="flex items-center gap-2 flex-1 min-w-0 flex-row-reverse justify-start"
            >
              <span
                class="hover:underline text-wrap truncate text-end"
                [ngClass]="{
                  'text-right': result.isLive
                }"
                >{{ result.awayTeam }}</span
              >
            </div>
          </div>

          <div class="hidden flex-col gap-1 max-sm:col-span-4 max-sm:flex">
            <!-- Home Team -->
            <div class="grid grid-cols-5 items-center">
              <div class="flex items-center gap-2 min-w-0 col-span-4">
                <span class="hover:underline text-wrap truncate">{{
                  result.homeTeam
                }}</span>
              </div>
            </div>

            <!-- Away Team -->
            <div class="grid grid-cols-5 items-center">
              <div class="flex items-center gap-2 flex-1 min-w-0 col-span-4">
                <span class="hover:underline text-wrap truncate">{{
                  result.awayTeam
                }}</span>
              </div>
            </div>
          </div>

          <div
            class="flex gap-3 max-sm:gap-2 items-center justify-center col-span-2 max-sm:text-10"
          >
            <img
              alt="logo"
              *ngIf="!result.isLive"
              [src]="urlIcon + 'clock-grey.svg'"
              class="max-sm:w-[16px]"
            />
            <span *ngIf="!result.isLive">{{ result.eventDate }}</span>

            <div
              class="bg-red-2 text-white rounded-5 text-14 max-sm:text-10 px-[7px] py-[5px]"
              *ngIf="result.isLive"
            >
              {{ "LIVE" | translate }}
            </div>
          </div>

          <div class="odd-tag" *ngIf="result.one?.Price">
            {{ result.one?.Price }}
          </div>
          <div class="odd-tag" *ngIf="result.x?.Price">
            {{ result.x?.Price }}
          </div>
          <div class="odd-tag" *ngIf="result.two?.Price">
            {{ result.two?.Price }}
          </div>
        </div>
      </div>
    </app-expansion-panel>
  </div>
</ng-container>

<div class="bg-white rounded-10 p-5 max-sm:p-3" *ngIf="isMatch && selected">
  <app-tab-bar
    filtersOptions="odds"
    (selectedIndexChange)="menuSelected($event)"
    [filters]="filters"
  ></app-tab-bar>

  <div
    class="flex flex-wrap gap-3 mt-3 max-sm:gap-2 max-sm:mt-2"
    *ngFor="let SingleResult of selected.results"
  >
    <div
      class="flex w-[calc(50%-0.375rem)] justify-between items-center bg-red-4 rounded-6 p-3 max-sm:p-2 text-blue font-roboto-400 max-sm:text-12"
      *ngFor="let score of SingleResult.scores"
    >
      <span>{{ score.text }}</span>
      <span>{{ score.scores }}</span>
    </div>
  </div>
</div>

<app-no-result
  *ngIf="groupedOddsList.length === 0 && !isLoading"
  message="NotAvalaibleInformation"
></app-no-result>
